import * as React from "react";
const SvgGrid1X2 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22,8h20v20h-20z m0,28h20v20h-20z" }));
export default SvgGrid1X2;
